<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-brand href="#">
      <img :src="logo" alt="Logo" class="brand-logo" />
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item v-b-toggle.sidebar-right>Show All Traders</b-nav-item>
        <b-nav-item id="nav-add-trader" v-b-modal.modal-prevent-closing>+ Add New Trader</b-nav-item>
        <b-nav-item id="nav-save" v-b-modal.modal-save-manager>Save / Load</b-nav-item>
        <b-nav-item v-b-modal.modal-feedback>Feedback</b-nav-item>
        <b-nav-item @click="$root.$emit('restart-tour')">Tutorial</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form> -->

        <!-- <b-nav-item-dropdown text="Lang" right>
          <b-dropdown-item href="#">EN</b-dropdown-item>
          <b-dropdown-item href="#">ES</b-dropdown-item>
          <b-dropdown-item href="#">RU</b-dropdown-item>
          <b-dropdown-item href="#">FA</b-dropdown-item>
        </b-nav-item-dropdown> -->

        <!-- <b-nav-item-dropdown right> -->
          <!-- Using 'button-content' slot -->
          <!-- <template v-slot:button-content>
            <em>User</em>
          </template>
          <b-dropdown-item href="#">Profile</b-dropdown-item>
          <b-dropdown-item href="#">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown> -->
        <!-- <a class="btn btn-success btn-sm btn-block mt-1" href="" target="blank">
        Git Repo</a> -->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import logo from '@/assets/logo.png'

export default {
  name: 'NavBar',
  data() {
    return {
      logo
    }
  }
}
</script>

<style scoped>
.brand-logo {
  height: 36px;
  width: auto;
}
</style>
